import React from 'react';
import PropTypes from 'prop-types';

const Loader = (props) => {
  const { customPadding, text } = props;
  let className = 'loader';
  if (customPadding === 'no-top') className += ` loader--no-padding-top`;
  if (customPadding === 'no-bottom') className += ` loader--no-padding-bottom`;
  if (customPadding === 'no-padding') className += ` loader--no-padding-top-bottom`;

  return (
    <div className={className}>
      <p>{text && `${text}...`}</p>
      <div className="loader__spinner"></div>
    </div>
  );
};

Loader.propTypes = {
  customPadding: PropTypes.oneOf(['no-top', 'no-bottom', 'no-padding'])
};

export default Loader;
